import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import keycloak from './keycloak';
import typePolicies from '../graphql/typePolicies';

const cacheOptions = { typePolicies };

const httpLink = createHttpLink({
  uri: window?.__ENV?.REACT_APP_API_URL,
  credentials: 'same-origin',
});

const authLink = setContext(async (_, { headers }) => {
  // Refresh token silently if it’s close to expiring.
  // updateToken(minValiditySeconds) resolves true if refreshed, false if still valid.
  try {
    if (keycloak && keycloak.authenticated && keycloak.token) {
      await keycloak.updateToken(30);
    }
  } catch (e) {
    // If refresh fails (expired session), we proceed without a token; callers will see 401.
    // You can optionally trigger a login here, but we keep it non-invasive.
    // console.warn('Keycloak updateToken failed', e);
  }

  const token = keycloak?.token;
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : '',
    },
  };
});

const client = new ApolloClient({
  uri: window?.__ENV?.REACT_APP_API_URL,
  cache: new InMemoryCache(cacheOptions),
  link: authLink.concat(httpLink),
});

export default client;
